const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUseroffwhiteopt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576.25,
    height: 541.97,
    viewBox: "0 0 576.25 541.97",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m239 0c-78.806 0-143 64.204-143 143 0 78.796 64.194 143 143 143s143-64.204 143-143c0-78.796-64.194-143-143-143zm0 30c62.594 0 113 50.416 113 113 0 62.584-50.406 113-113 113s-113-50.416-113-113c0-62.584 50.406-113 113-113zm-50.699 274c-103.8 0-188.3 84.491-188.3 188.3 0 27.249 22.406 49.67 49.66 49.67h378.68c27.251 0.04272 49.664-22.397 49.664-49.67 0-103.81-84.492-188.3-188.3-188.3zm0 30h101.4c87.591 0 158.3 70.709 158.3 158.3 0 11.127-8.5881 19.687-19.617 19.67h-378.72c-11.026 0-19.66-8.6386-19.66-19.67 0-87.59 70.72-158.3 158.3-158.3z",
    style: {
      colorRendering: "auto",
      color: "#000000",
      dominantBaseline: "auto",
      fill: "#fff",
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      imageRendering: "auto",
      isolation: "auto",
      mixBlendMode: "normal",
      shapePadding: 0,
      shapeRendering: "auto",
      solidColor: "#000000",
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUseroffwhiteopt);
export default __webpack_public_path__ + "static/media/user.off.white.opt.2de9139350baaabb0ee49b996f1fbfb4.svg";
export { ForwardRef as ReactComponent };